import { AdunitTheme } from '@/components/Adunit/theme';
import { ArticleTeaserDefaultTheme } from '@/components/ArticleTeaser/Default/theme';
import { RowTheme } from '@/components/Row/theme';
import { SpinnerTheme } from '@/components/Spinner/theme';
import { tw } from '@/utils/tw';

const theme = tw.theme({
  slots: {
    base: ['p-6', '[&_em]:text-gray-500'],
  },
});

export default Object.assign(theme, {
  Adunit: AdunitTheme,
  Row: RowTheme,
  SearchItem: ArticleTeaserDefaultTheme,
  Spinner: SpinnerTheme,
});
